import { HttpDelete, HttpGet, HttpPost, HttpPut } from '@/services/Service'
import type { SpatieQueryBuilderParameters } from '@/misc/custom-types'

export default class UserService {
  static async get (id: number, params: SpatieQueryBuilderParameters = {}) {
    return await HttpGet(`/api/v1/users/${id}`, { params })
  }

  static async getCurrent () {
    return await HttpGet('/api/v1/user')
  }

  static async fetch (params = {}) {
    return await HttpGet('/api/v1/users', { params })
  }

  static async post (data) {
    return await HttpPost('/api/v1/users', data)
  }

  static async put (id, data = {}) {
    return await HttpPut(`/api/v1/users/${id}`, data)
  }

  static async delete (id, config = {}) {
    return await HttpDelete(`/api/v1/users/${id}`, config)
  }

  static async resetTwoFactor (id: number) {
    return await HttpPost(`/api/v1/users/${id}/reset-two-factor`)
  }

  static async logout () {
    return await HttpGet('/logout')
  }

  static async search (query, filter: any = {}, include: string | string[] = []) {
    const params = { filter } as any

    params.filter.search = query

    if (include.length > 0) {
      params.include = include
    }

    return await HttpGet('/api/v1/users', {
      params
    })
  }

  static async sendUserInvitationMail (userIds, data = {}, config = {}) {
    return await HttpPost('/api/v1/users/send-user-invitation', {
      user_ids: userIds.map((id) => {
        return { user_id: id }
      }),
      ...data
    }, config)
  }
}
